import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import SanitaryInspectorForm from './InspectorForm'
import '../../App.css'
import * as actionsCreators from '../../store/actions/index'
import axios from '../../http-config';
import _ from 'lodash'


function  EditSi(props) {
    const [singleUser, setUser] = useState({}); 
    useEffect(() => {
        const payload = {
                        token : props.token,
                        id    : props.match.params.id
        }
        const url = `user?userId=${payload.id}`
        axios({
                        method   : 'get',
                        url      : url,
                        headers  : {'Authorization': `Bearer ${payload.token}`}
                   })
                   .then((response) => {
                       setUser(response.data.data.users[0])
                   })
                   .catch((err) => {
                       
                   })
      },[]);
    
    const handleSubmit = (formdata)=>{
        props.onEditSiUserData(formdata ,props)
    }

        return(
            
            <div className="create_ulb">
            <div className="dashboard_top_path">
                <p><img src="images/left-arrow.svg" /> ULB Officer Management / <span>Edit User</span></p>
            </div>
            <div className="dashboard_right_content">
                <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                <div className="dashboard_right_content_top">
                    <h5>Edit User</h5>
                </div>
                <div className="create_ulb_content_outer">
                    <div className="create_ulb_content">
                { 
                 !_.isEmpty(singleUser)&&(
                     <SanitaryInspectorForm {...singleUser} id={props.match.params.id} disabled={true} handleSubmit={handleSubmit}/>
                 )
                }      
                    </div>
                </div>
            </div>
        </div>
                
        )
}



const mapStateToProps = (state,props) => {
    
return {
    token:state.auth.token
}
}

const mapDispatchToProps = dispatch => {
return {
    onEditSiUserData: (formdata, props) => dispatch(actionsCreators.editSiUserData(formdata, props))
}
}

export default  connect(mapStateToProps, mapDispatchToProps)(EditSi);

